import { WechatRoom } from "../../types";
import EventBus from "../event-bus";
const getRoomDetailHook = new EventBus<WechatRoom>("getRoomDetailHook");

export default getRoomDetailHook;
